import { render, staticRenderFns } from "./pre_table_nokey2.vue?vue&type=template&id=ef80a2fa&scoped=true"
import script from "./pre_table_nokey2.vue?vue&type=script&lang=js"
export * from "./pre_table_nokey2.vue?vue&type=script&lang=js"
import style0 from "./pre_table_nokey2.vue?vue&type=style&index=0&id=ef80a2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef80a2fa",
  null
  
)

export default component.exports